module.exports = __webpack_public_path__ + "img/CM-SL-CA-Volkswagen-Lifestyle.a6174d37.jpg";